<template>
	<div class="payment-wrap">
		<div id="myfroms"></div>
		<cIndex  ref="header"></cIndex>
		<div class="payment">
			<div class="payment-left">
				<div class="combo-option">
					<h4>选择类型</h4>
					<ul>
						<li v-for="(item,index) in typeList" @click="getCurrentTyle(index+1)" :class="current==index+1?'on':''">{{item}}</li>
					</ul>
					<h4>选择套餐</h4>
					<ul>
						<option v-for="(item,index) in comboList" @click="getCurrentCombo(index+1)"  :class="comboCurrent==index+1?'on':''" :disabled="item.disabled">
							{{item.label}}
						</option>
					</ul>
					<h4>支付方式</h4>
					<ul class="zfb">
						<li v-for = '(item,index) in imgList'  @click="getCurrentpay(index+1)" :class = "payCurrent == index+1?'on':'' " >
							<img :src="item.imgUrl">
							{{item.payimg}}
						</li>
	 				</ul>
	 				<el-form class="payMoneyInput" :model="userInfomationpay" :rules="rules" ref="userInfomationpay" v-show = "payInput">
	 					<el-form-item prop="cardnumRoll">
	 						<input type="text" v-model = "userInfomationpay.cardnumRoll" placeholder="请输入电子卡10位密码">
	 						<b v-show = "payMoneyMess">请输入正确的电子卡密码</b>
	 					</el-form-item>
	 					<el-button @click="goPayEnter('userInfomationpay')">确认</el-button>
	 				</el-form>
				</div>
				<div class="payment-button">
					<p v-show="isNullMoney">原价 <span class="oldMoney">￥{{Originalprice}}</span></p>
					<p v-show="isNullMoney">支付卡减免 <span class="oldMoney">-￥{{Discount}}</span></p>
					<p>应付金额 <span>￥{{introduceList.price}}</span></p>
					<button @click="goPayment('userInfomationpay')">立即支付</button>
				</div>
			</div>
			<div class="payment-right">
				<div class="payment-banner"> 
					<img :src="introduceList.imgUrl" alt="图片">
				</div>
				<div class="padding-introduce">
					<span><b>{{introduceList.packageVal}} — </b>{{introduceList.name}}</span>
					<p>
						{{introduceList.introduce}}
					</p>
				</div>
			</div>
		</div>
		<div class="payment-mark" v-show="isPaymentShow">
			<div class="mark-content">
				<h4>线上支付提示</h4>
				<p>支付完成前，请不要关闭此支付验证窗口</p>
				<p>完成支付后，请根据您的支付的情况点击下面按钮</p>
				<div>
					<span @click='getPaymentProblem'>支付遇到问题</span>
					<b style="width: .3rem;"></b>
					<span @click='getPaymentSuccess'>支付完成</span>
				</div>
			</div>
		</div>
	</div>	
</template>
<script>
    import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	import store from '../vuex/store';
	import {mapGetters} from 'vuex';
	import zfbpayPng from '../assets/zfbz.png';
	import weixinpayPng from '../assets/wxz.png';
	import cardpayPng from '../assets/cardRoll.png';
	export default {
		components: components,
		data(){ 
			return {
				payInput:false,
				payMoneyMess:false,
				isNullMoney:false,
				typeList: ["青年版","中年版","老年版","儿童版"],
				// comboList: ["基础套餐","标准套餐"],
				comboList: [{
					  value: '1',
					  label: '基础套餐'
				},{
					 value: '2',
					 label: '标准套餐',
					 disabled: true
				}],
				// comboList: ["基础套餐","标准套餐","升级套餐","VIP套餐"],
				imgList:[
					  { 
					  	imgUrl: zfbpayPng,
					  	'payimg' :'支付宝'
					  	 },
		              { 
		              	imgUrl: weixinpayPng,
		              	'payimg' :'微信支付' 
		              },
		              { 
		              	imgUrl: cardpayPng ,
		              	'payimg' :'电子卡'
		              },
				],
				current: this.$route.query.pID,
				comboCurrent: 1,
				payCurrent:1,
				introduceList: null,
				PID:'',
				BID:'',
				MID:'',
				isPaymentShow: false,
				content: "",
				checkPasswordStatus:'',
				Originalprice:'',
				Discount:'',
				userInfomationpay:{
					cardnumRoll:'',
				},
				introduceList: {
					price: ''
				},
				rules:{
				},
			}
		}, 
		methods: {
			getCurrentTyle(pid){
				this.current = pid
				this.getPackageId(pid,this.comboCurrent)
				if(this.current == 4){
					this.comboList[1].disabled = false;
				}else{
					this.comboCurrent = 1;
					this.comboList[1].disabled = true;
				}
			},
			getCurrentCombo(bid){
				this.comboCurrent = bid
				this.getPackageId(bid,this.current)
				if(bid == 2){
					// console.log()
				}
			},
			getCurrentpay(mid){
				this.payCurrent = mid;
				this.getPackageId(mid,this.payCurrent)
					if(this.payCurrent == 3){
						this.payInput = true;
					}else{
						this.payInput = false;
					}
			},
			getPackageId(pid,bid,mid){
				this.PID = this.current;
				this.BID = this.comboCurrent;
			    this.MID = this.payCurrent;
			    var a = Number(this.current)
			    var b = Number(2)
				this.$http.post(urls.urltest + "/personal/getPackagevaBuvInfo.json",{
					pid: a+b,
					bid: this.comboCurrent
				})
				.then(function(res){
					this.introduceList = res.body;
					this.Originalprice = res.body.price;//原价
					this.Discount = res.body.price;//折价
				})
			},
			goPayment(formName){
				$.getScript('http://int.dpool.sina.com.cn/iplookup/iplookup.php?format=js',function(){   
					var payCountry = remote_ip_info.country;
					var payProvince = remote_ip_info.province;
					var payCity = remote_ip_info.city
			    	localStorage.setItem('payCountry',payCountry)
			    	localStorage.setItem('payProvince',payProvince)
			    	localStorage.setItem('payCity',payCity)
				});
				var token = localStorage.getItem('token');
				var addressCountry = localStorage.getItem('payCountry')+localStorage.getItem('payProvince') + localStorage.getItem('payCity')
				if(token){
					var a = Number(this.current)
			    	var b = Number(2)
					if(this.MID == 1  || this.MID ==2){
						this.$http.post(urls.urltest + "/order/saveOrder.json", {
							pid: a+b,
							bid: this.BID,
							token:token,
							payType:this.MID,
							address: addressCountry
						}).then(function(res) {
							localStorage.setItem('eid', res.body.eid)
							localStorage.setItem('orderNumber', res.body.ordernumber)
							this.isPaymentShow = true;
							if(this.MID == 1){
								var ordernumber = localStorage.getItem('orderNumber')
								window.open(urls.urltest + "/alipay/zfbpay.json"+'?ordernumber='+ordernumber)
							}else{
								// window.open('/#/payWeChat')
									var winHandler = window.open("","_blank");
								 winHandler.location.href = '/#/payWeChat';
							}
					})
					}else{
						var addressCountry = localStorage.getItem('payCountry')+localStorage.getItem('payProvince') + localStorage.getItem('payCity')
						this.$refs[formName].validate((valid) => {
							if( this.checkPasswordStatus == 1){
								this.$http.post(urls.urltest + "/order/saveOrder.json", {
								pid: a+b,
								bid: this.BID,
								token:localStorage.getItem('token'),
								payType:this.MID,
								password:this.userInfomationpay.cardnumRoll,
								address: addressCountry
								}).then(function(res) {
								console.log(res.body)
								localStorage.setItem('eid', res.body.eid)
								localStorage.setItem('orderNumber', res.body.ordernumber)
								this.$router.replace('/cardSucc')
								})
							}else{
								this.$http.post(urls.urltest + "/order/checkPassword.json", {
									pid: a+b,
									bid: this.BID,
									token:localStorage.getItem('token'),
									password:this.userInfomationpay.cardnumRoll
									}).then(function(res) {
										this.checkPasswordStatus = res.body
											if(res.body == ''){
												this.payMoneyMess = true;
											}else if(res.body == 0){
												this.payMoneyMess = true;
											}
										if(res.body > 0){
											this.payMoneyMess = false;
											this.isNullMoney = true
											this.introduceList.price = '0.00';
										this.$http.post(urls.urltest + "/order/saveOrder.json", {
										pid: a+b,
										bid: this.BID,
										token:localStorage.getItem('token'),
										payType:this.MID,
										password:this.userInfomationpay.cardnumRoll,
										address: addressCountry
										}).then(function(res) {
										console.log(res.body)
										localStorage.setItem('eid', res.body.eid)
										localStorage.setItem('orderNumber', res.body.ordernumber)
										this.$router.replace('/cardSucc')
										})
									}
								})
							}
						})
					}
				}else{
					this.$refs.header.goLogin();
				}
			},
			getPaymentProblem(){
				this.isPaymentShow = false;
				this.$router.replace('/ordermanagement')
			},
			getPaymentSuccess(){
				var ordernumber = localStorage.getItem('orderNumber')
				this.$http.post(urls.urltest + "/order/getOrderInfo.json",{
				ordernumber:ordernumber,
				token:localStorage.getItem('token')
				}).then(function(res){
					if(res.body.orderstatus == '2'){
							this.$http.post(urls.urltest + "/personal/checkUser.json",{
							token:localStorage.getItem('token'),
							phone:localStorage.getItem('phone')
						}).then(function(res){
							if(res.body == '0'){
								 this.$router.push('/startTest')
								}else{
								this.$router.push('/gamelist')
							}
						})
					}else{
						this.$router.replace('/ordermanagement')
					}
				})
			},
			goPayEnter(formName){
				var c = Number(this.current)
			    var b = Number(2)
				if(this.MID == 3){
					this.$refs[formName].validate((valid) => {
							var token = localStorage.getItem('token')
							if(token){
								var a = this.userInfomationpay.cardnumRoll
								this.$http.post(urls.urltest + "/order/checkPassword.json", {
											pid: c+b,
											bid: this.BID,
											token:token,
											password:this.userInfomationpay.cardnumRoll
										}).then(function(res) {
										this.checkPasswordStatus = res.body
										if(this.checkPasswordStatus > 0){
											this.payMoneyMess = false;
											this.isNullMoney = true
											this.introduceList.price = '0.00';
		
										}else if( this.checkPasswordStatus == '' ){
											this.payMoneyMess = true;
										}else if(this.checkPasswordStatus = 0){
											this.payMoneyMess = true;
										}
									})
							}else{
								this.$refs.header.goLogin();
							}
					})
				}
			},
		},
		store,
		computed: {
	      ...mapGetters([
	        'tyleInd',
	        'comboInd'
	      ])
	    },
		mounted(){
			console.log(this.current)
			if(this.current == 4){
					this.comboList[1].disabled = false;
			}
			this.getPackageId(this.current,this.comboCurrent)
			 $('.zfb li').click(function() {
	            var i = $(this).index();//下标第一种写法
	            // var i = $('.zfb').index(this);//下标第二种写法
	            $(this).addClass('on').siblings().removeClass('on');
        	});
		},
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	.payment-wrap{
		position: relative;
		@include flexbox;
		@include flex-direction(column);
		.payment{
			width: 12rem;
			background: #fff;
			margin: .2rem auto;
			box-shadow: 0 0 3px #C3C3C3;
			@include flexbox;
			.payment-left{
				@include flex;
				.combo-option{
					margin: 0 .6rem 0 .4rem;
					padding-bottom: .59rem;
					border-bottom: 1px dashed #999999;
					h4{
						font-size: 16px;
						color: #999999;
						font-weight: normal;
						padding: .4rem 0 .2rem 0;
					}
					ul{ 
						@include flexbox;
						option,li{
							width: 1.27rem;
							height: .48rem;
							box-shadow: 0 0 3px #C3C3C3;
							text-align: center;
							line-height: .48rem;
							font-size: 16px;
							color: #555555;
							cursor: pointer;
							&:not(:first-child){
								margin-left: .2rem;
							};
							&.on{
								border: 1px solid #467DE5;
								box-sizing: border-box;
								font-weight: bold;
								background: url(../assets/Rectangle.png) no-repeat  1.11rem 0.34rem;
							}
						}
						&.zfb{
							li{
								img{
									line-height: .48rem;
									padding-right: .13rem;
									width: 0.27rem;
									height: 0.27rem;
								}
							}

						}
						&.Package-on{
							width: 1.27rem;
							height: .48rem;
							box-shadow: 0 0 3px #C3C3C3;
							text-align: center;
							line-height: .48rem;
							font-size: 16px;
							color: #555555;
							cursor: pointer;
							&:not(:first-child){
								margin-left: .2rem;
							};
							&.on{
								border: 1px solid #467DE5;
								box-sizing: border-box;
								font-weight: bold;
								background: url(../assets/Rectangle.png) no-repeat  1.11rem 0.34rem;
							}
						}
					}
					.payMoneyInput {
						@include flexbox;
						margin-top: 0.31rem;
						b{
							display:block;
							color:#f00;
						}
						input{
							width: 100%;
							width: 4.21rem;
							background: #F4F5F8;
							border: 1px solid #EEEEEE;
							height: 0.48rem;
							line-height: 0.478rem;
							font-family: PingFangTC-Regular;
							font-size: 16px;
							color: #888888;
							text-indent: 0.12rem;
						}
						button{
							width: 1.28rem;
							outline: none;
							border-radius: 0;
							height: 0.47rem;
							background: #467DE5;
							box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);
							margin-left: 0.20rem;
							border:none;
							font-family: PingFangTC-Semibold;
							font-size: 18px;
							color: #FFFFFF;
							cursor: pointer;
						}
					}
				}
				.payment-button{
					padding: 1.03rem 0 2.13rem 0;
					text-align: right;
					padding-right: .6rem;
					p{
						font-size: 16px;
						color: #444444;
						span{
							padding-left: .2rem;
							color: red;
							font-size: .2rem;
							font-weight: bold;
						}
					}
					.oldMoney{
							color: #000000;
						}
					button{
						font-size: .14rem;
						width: 2.4rem;
						height: .35rem;
						color: #fff;
						text-align: center;
						line-height: .35rem;
						background: #467DE5;
						border: none;
						margin-top: .23rem;
						cursor: pointer;
					}
				}
			}
			.payment-right{
				width: 5.28rem;
				.payment-banner{
					width: 4.88rem;
					height: 4.16rem;
					box-sizing: border-box;
					padding: .5rem 0;
					border-bottom: 1px dashed #999;
					img{
						display: block;
						width: 100%;
						height: 100%;
					}
				}
				.padding-introduce{
					span{
						font-size: 18px;
						color: #555555;
						display: block;
						padding: .17rem 0;
					}
					p{
						font-size: .16rem;
						color: #666;
						width: 4.88rem;
						line-height: .28rem;
					}
				}
			}
		}
		.payment-mark{
			position: absolute;
			background: rgba(0,0,0,0.7);
			@include flex;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: 9991;
			.mark-content{
				width: 5.5rem;
				height: 3.14rem;
				background: #fff;
				margin: 20% auto 0 auto; 
				border-radius: .03rem;
				h4{
					width: 100%;
					height: .6rem;
					text-align: center;
					line-height: .6rem;
					color: #555;
					font-size: .16rem;
					border-bottom: 1px solid #eee;
					margin-bottom: .4rem;
				}
				p{
					text-align: center;
					font-size: 14px;
					color: #555;
					padding-bottom: .1rem;
				}
				div{
					text-align: center;
					padding-top: .55rem;
					b{
						display: inline-block;
					}
					span{
						display: inline-block;
						width: 1.2rem;
						height: .3rem;
						color: #fff;
						text-align: center;
						line-height: .3rem;
						box-shadow: 0 0 3px #6d6c6c;
						font-size: .12rem;
						cursor: pointer;
						&:first-child{
							background: #bbb;
						}
						&:last-child{
							background: #467DE5;
						}
					}
				}
			}
		}
		/*.el-form-item__error {
	        color: #ff4949;
		    font-size: 0.16rem;
		    line-height: 130px;
		    position: absolute;
		    left: 0;
		}*/
	}
</style>


// WEBPACK FOOTER //
// payment.vue?f3ffd6f0